import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { connect } from "react-redux";
import QuoteCreate from './Create';
import QuoteDetail from './Detail';
import QuoteList from './List';
import Common from '../../../../shared/common';
import { allMessages } from "../../../../../_metronic/i18n/I18nProvider";
// import { supplier, supplierAndManagerOrSupport, supplierAndManager } from '../../../../Templates/TemplateHelper';

export const compensationQuotableStatuses = ['AQ', 'APMRQ', 'ARQ', 'ADAQ'];
export const compensationQuotableStatusesShort = ['AQ', 'APMRQ', 'ARQ', 'APMR', 'ADAQ'];

const defaultFields = {
    Title: { visible: false, label: '', required: false },
    Note: { visible: false, label: '', required: false },
    ContinuingEffect: { visible: false, label: '', required: false },
    Comments: { visible: false, label: '', required: false },
    PriceEffect: { visible: false, label: '', required: false },
    DateEffectOptions: { visible: false, label: '', required: false },
    ProgrammeDetails: { visible: false, label: '', required: false },
    DateEffect: { visible: false, label: '', required: false },
    AttachedProgramme: { visible: false, label: '', required: false },
}

const defaultReplyFields = {
    ReplyAmount: { visible: false, label: '', required: false },
    ReplyDays: { visible: false, label: '', required: false },
    ReplyStatus: { visible: false, label: '', required: false },
    ReplyComment: { visible: false, label: '', required: false },
    ReplyProceed: { visible: false, label: '', required: false },
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getQuoteFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract, componentProps) => {
    const fields = { ...defaultFields };

    fields.Title = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.TITLE"], required: true };

    if (componentProps) {
        let parentReferenceID = componentProps.compensation ? componentProps.compensation.referenceid : componentProps.instruction.referenceid;
        if (wfid === 6 && resources.QuoteNoteProposedInstruction) {
            fields.Note = { visible: true, label: resources.QuoteNoteProposedInstruction.replace('$reference', parentReferenceID), required: true };
        }
        else {
            if (resources.QuoteNote) {
                let quoteNote = (resources.QuoteNote || '');
                if (quoteNote.includes("$reference")) {
                    //FD-8804
                    quoteNote = quoteNote.replace('$reference', parentReferenceID);
                }
                else {
                    //support historic template configurations FD-8804
                    quoteNote = quoteNote + ' ' + parentReferenceID;
                }
                fields.Note = { visible: true, label: quoteNote, required: true };
            }
        }
    }

    if ((wfid === 75 || wfid === 67 || wfid === 0) && placeholdersQA.INTERIM_QUOTES_ALLOWED) {
        const interimQuotesAllowed = placeholdersQA.INTERIM_QUOTES_ALLOWED.values.find(phItem => phItem.field === 'INTERIM_QUOTES_ALLOWED').isActive;
        if (interimQuotesAllowed) {
            fields.ContinuingEffect = { visible: true, label: resources.QuoteContinuingEffectLabel, required: true };
            fields.ContinuingEffect.continuingEffectOptions = [
                { value: 1, display: languageFile['GENERAL.FORMS.SWITCH_YES'] },
                { value: 0, display: languageFile['GENERAL.FORMS.SWITCH_NO'] },
            ];
        }
    }

    fields.Comments = { visible: true, label: languageFile["CONTRACT.WF.QUOTES.FIELD.SUMMARY"], required: true };

    if (contract?.ispackaged !== true && componentProps?.compensation?.clauseeffect !== "EFFECT_DATES_ONLY") {
        fields.PriceEffect = { visible: true, label: resources.QuoteCostEffectLabel, required: true };
    }
    if (componentProps?.compensation?.clauseeffect !== "EFFECT_AMOUNTS_ONLY") {
        fields.DateEffectOptions = { visible: true, label: resources.QuoteDateEffectLabel, required: true };
        fields.DateEffectOptions.quoteImpactOptions = placeholdersQA.QuoteProgrammeImpactOpts.values.filter((item) => item.isActive === true)

        fields.ProgrammeDetails = { visible: true, label: languageFile["CONTRACT.WF.QUOTES.FIELD.PROGRAMME_DETAILS"], required: true };
        fields.DateEffect = { visible: true, label: resources.QuoteDaysEffectLabel, required: true };
        fields.AttachedProgramme = { visible: true, label: resources.QuoteProgrammeAttachLabel, required: true };
        fields.AttachedProgramme.options = [languageFile["GENERAL.FORMS.SWITCH_YES"], languageFile["GENERAL.FORMS.SWITCH_NO"]];

    }

    return fields;
}

///ALL REPLY FIELDS ARE DECIDED WITHIN THE getReplyFields FUNCTION
///THE getReplyFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign replyFields to workflowItem
export const getQuoteReplyFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract, componentProps) => {
    const replyFields = { ...defaultReplyFields };
    const workflowItem = workflowsQA[wfid];

    if (contract?.ispackaged !== true) {
        replyFields.ReplyAmount = { visible: true, label: languageFile["CONTRACT.WF.QUOTES.FIELD.AMOUNT"], required: false };
    }
    replyFields.ReplyDays = { visible: true, label: resources.QuoteDaysEffectLabel, required: false };

    replyFields.ReplyStatus = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.STATUS"], required: true };
    //provide all possible replies as options will need to be recalculated  per quote
    //it may change on communicated quote properties
    //these options are provided to be used in master quote imports etc.
    replyFields.ReplyStatus.replyOptions = [
        { field: '1', display: 'Accepted' },
        { field: '0', display: 'NotAccepted_SupplierToResubmit' },
        { field: '3', display: 'NotAccepted_PmToMakeAssessment' },
        { field: '5', display: 'NotAccepted_DecisionWillNotBeGiven' },
        { field: '8', display: 'Acknowledged' },
    ];
    replyFields.ReplyComment = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COMMENTS"], required: true };
    if ((wfid === 6 || wfid === 0) && placeholdersQA.InstructionReplyProceedEnabled) {
        const instructionReplyProceedEnabled = placeholdersQA.InstructionReplyProceedEnabled.values.find(phItem => phItem.field === 'InstructionReplyProceedEnabled').isActive;
        if (instructionReplyProceedEnabled && placeholdersQA.InstructionReplyProceedOpts) {
            replyFields.ReplyProceed = { visible: true, label: languageFile["CONTRACT.WF.QUOTES.FIELD.PROCEED"], required: false };
            replyFields.ReplyProceed.proceedOptions = placeholdersQA.InstructionReplyProceedOpts.values.filter(item => item.isActive === true);
        }
    }


    return replyFields;
}
class QuoteRouter extends React.Component {
    constructor(props) {
        super(props);
        this.notifyingParty = props.parentWorkflowItem.quotingParty;
        this.replyingParty = props.parentWorkflowItem.quoteReplyingParty;


        this.notificationType = props.parentWorkflowItem.config.quotationType;
        this.documentType = props.parentWorkflowItem.config.quotationDocumentType;

        this.referenceType = 'Quotation';

        this.notificationName = props.parentWorkflowItem.quoteNotificationName;// this.props.intl.formatMessage({ id: 'GENERAL.WORDS.QUOTE' });
        this.abbreviation = props.parentWorkflowItem.quoteReferencePrefix; //Common.CapitalFirstLetter(this.notificationName) + "-";
        this.pageTitle = this.props.intl.formatMessage({ id: 'GENERAL.NOTICE.TITLE' }, { ITEM_NAME: this.notificationName, PARTY_NAME: props.globalResources[this.notifyingParty + "_NAME"] });
        const fields = getQuoteFields(props.resources, props.placeholdersQA, props.workflowsQA, allMessages[this.props.lang], this.props.workflowItem.id, props.globalResources, props.contract, props);
        const replyFields = getQuoteReplyFields(props.resources, props.placeholdersQA, props.workflowsQA, allMessages[this.props.lang], this.props.workflowItem.id, props.globalResources, props.contract, props);
        //Create a Custom WorkflowItem for Quote as its not a WF standalone
        this.workflowItem = {
            ...props.parentWorkflowItem,
            fields: fields,
            replyFields: replyFields,
            pageTitle: this.pageTitle,
            notificationName: this.notificationName,
            abbreviation: this.abbreviation,
            replyEnabled: true,
            notifyingParty: props.parentWorkflowItem.quotingParty,
            replyingParty: props.parentWorkflowItem.quoteReplyingParty,
            notifyAttachments: props.parentWorkflowItem.notifyAttachments,
            replyAttachments: props.parentWorkflowItem.notifyAttachments,
            includePdfjson: props.parentWorkflowItem.includePdfjson,
            userFilters: {
                ...props.parentWorkflowItem.userFilters,
                mainNotice: {
                    createFilter: props.parentWorkflowItem.userFilters.quoteMainNotice.createQuoteFilter,
                    createAllowed: props.parentWorkflowItem.userFilters.quoteMainNotice.createQuoteAllowed,
                    viewDraftFilter: props.parentWorkflowItem.userFilters.quoteMainNotice.createQuoteFilter,
                    viewDraftAllowed: props.parentWorkflowItem.userFilters.quoteMainNotice.createQuoteAllowed,
                    communicateFilter: props.parentWorkflowItem.userFilters.quoteMainNotice.communicateQuoteFilter,
                    communicateAllowed: props.parentWorkflowItem.userFilters.quoteMainNotice.communicateQuoteAllowed
                },
                replyNotice: {
                    saveDraftReplyFilter: props.parentWorkflowItem.userFilters.quoteReplyNotice.saveQuoteDraftReplyFilter,
                    saveDraftReplyAllowed: props.parentWorkflowItem.userFilters.quoteReplyNotice.saveQuoteDraftReplyAllowed,
                    communicateReplyFilter: props.parentWorkflowItem.userFilters.quoteReplyNotice.communicateQuoteReplyFilter,
                    communicateReplyAllowed: props.parentWorkflowItem.userFilters.quoteReplyNotice.communicateQuoteReplyAllowed
                }
            },
            paths: {
                ...props.parentWorkflowItem.paths,
                basePath: props.parentWorkflowItem.paths.basePath + this.props.compensation.compensationeventid + "/quote/",
                createPath: props.parentWorkflowItem.paths.basePath + this.props.compensation.compensationeventid + "/quote/create",
                listPath: props.parentWorkflowItem.paths.basePath + this.props.compensation.compensationeventid,
                defaultPath: props.parentWorkflowItem.paths.basePath + this.props.compensation.compensationeventid,
            },
            config: {
                ...props.parentWorkflowItem.config
            },
            associatedWFListAllowed: null
        };

        this.workflowItem.form_NotifyCompanyLogoID = Common.GetPartyOrUserCompanyID(props.contract, this.workflowItem.form_CompanyLogo, this.workflowItem.notifyingParty, props.userProfile);
        this.workflowItem.form_NotifyCompanyName = Common.GetPartyOrUserCompanyName(props.contract, this.workflowItem.form_CompanyName, this.workflowItem.notifyingParty, props.userProfile);
        this.workflowItem.form_ReplyCompanyLogoID = Common.GetPartyOrUserCompanyID(props.contract, this.workflowItem.form_CompanyLogo, this.workflowItem.replyingParty, props.userProfile);
        this.workflowItem.form_ReplyCompanyName = Common.GetPartyOrUserCompanyName(props.contract, this.workflowItem.form_CompanyName, this.workflowItem.replyingParty, props.userProfile);



    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.compensation !== nextProps.compensation) {
            return true;
        }
        return false;
    }
    render() {

        const baseNotificationReadyForCreate = (this.props.parentWorkflowItem.id === 84 || this.props.mode === 'SHORT' || this.props.mode === 'CLAIMWN' || this.props.mode === 'CLIENTCWN') ? compensationQuotableStatusesShort.includes(this.props.compensation.status) : compensationQuotableStatuses.includes(this.props.compensation.status);
        // const canCreate = this.workflowItem.userFilters.quoteMainNotice.createQuoteAllowed && baseNotificationReadyForCreate;
        // this.workflowItem.basePath = this.props.parentWorkflowItem.basePath + baseNotification.compensationeventid + "/quote/";
        // this.workflowItem.registerPath = this.props.parentWorkflowItem.basePath + baseNotification.compensationeventid;

        return (
            <Routes caseSensitive>
                <Route
                    path={'/quote/create'}
                    exact
                    element={
                        baseNotificationReadyForCreate && this.workflowItem.userFilters.quoteMainNotice.createQuoteAllowed ? (
                            <QuoteCreate
                                {...this.props}
                                interimQuotesAllowed={this.interimQuotesAllowed}
                                mode={this.props.mode}
                                parentTabPanel={this.props.parentTabPanel}
                                title={this.notificationName}
                                abbreviation={this.abbreviation}
                                notificationType={this.notificationType}
                                workflowItem={this.workflowItem}
                            />) : (
                            <Navigate replace to={this.workflowItem.paths.defaultPath} />
                        )
                    }
                />

                <Route
                    path={'/quote/:quotationid'}
                    exact
                    element={<QuoteDetail
                        {...this.props}
                        interimQuotesAllowed={this.interimQuotesAllowed}
                        mode={this.props.mode}
                        parentTabPanel={this.props.parentTabPanel}
                        onCompensationChanged={this.props.onCompensationChanged}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        documentType={this.documentType}
                        baseNotificationReadyForCreate={baseNotificationReadyForCreate}
                        notificationType={this.notificationType}
                        notifyUserFilter={this.props.notifyUserFilter}
                        workflowItem={this.workflowItem}
                    />}
                />

                <Route
                    path="*"
                    element={<QuoteList
                        {...this.props}
                        mode={this.props.mode}
                        interimQuotesAllowed={this.interimQuotesAllowed}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        workflowItem={this.workflowItem}
                        notificationType={this.notificationType}
                        baseNotificationReadyForCreate={baseNotificationReadyForCreate}
                        reference={this.props.reference}
                        notifyingParty={this.notifyingParty}
                    />}
                />

            </Routes>
        );
    }
};


const mapStateToProps = store => ({
    //WE NEED userProfile because Common.GetPartyOrUserCompanyID is re-assigned depending on party
    userProfile: store.auth.userProfile,
    lang: store.i18n.lang,
});
export default connect(mapStateToProps)(QuoteRouter);